import { getAssetsPath } from '@/common'
import { loadImage } from './assets'

const glyphs: Record<
  string,
  { index: number; x: number; y: number; width: number; height: number }
> = {
  hrb20: {
    index: 1,
    x: 0,
    y: 0,
    width: 733,
    height: 87
  },
  hrb23: {
    index: 1,
    x: 0,
    y: 96,
    width: 724,
    height: 87
  },
  hrb22: {
    index: 1,
    x: 0,
    y: 192,
    width: 724,
    height: 87
  },
  hrb28: {
    index: 1,
    x: 0,
    y: 288,
    width: 719,
    height: 87
  },
  hrb24: {
    index: 1,
    x: 0,
    y: 384,
    width: 714,
    height: 87
  },
  hrb21: {
    index: 1,
    x: 0,
    y: 480,
    width: 700,
    height: 87
  },
  hrb27: {
    index: 1,
    x: 0,
    y: 576,
    width: 692,
    height: 87
  },
  hrb25: {
    index: 1,
    x: 0,
    y: 672,
    width: 617,
    height: 87
  },
  hrb26: {
    index: 1,
    x: 0,
    y: 768,
    width: 605,
    height: 87
  },
  hrb10: {
    index: 1,
    x: 0,
    y: 864,
    width: 593,
    height: 87
  },
  hbg001m: {
    index: 1,
    x: 615,
    y: 768,
    width: 389,
    height: 87
  },
  hrb4: {
    index: 1,
    x: 627,
    y: 672,
    width: 378,
    height: 87
  },
  hrb3: {
    index: 1,
    x: 603,
    y: 864,
    width: 371,
    height: 87
  },
  hrb38: {
    index: 1,
    x: 702,
    y: 576,
    width: 308,
    height: 77
  },
  hrb29: {
    index: 1,
    x: 743,
    y: 0,
    width: 239,
    height: 87
  },
  hrb35: {
    index: 1,
    x: 734,
    y: 96,
    width: 227,
    height: 77
  },
  hbgau: {
    index: 1,
    x: 734,
    y: 182,
    width: 95,
    height: 87
  },
  hbgav: {
    index: 1,
    x: 839,
    y: 182,
    width: 95,
    height: 87
  },
  hbgax: {
    index: 1,
    x: 734,
    y: 278,
    width: 95,
    height: 87
  },
  hbgay: {
    index: 1,
    x: 839,
    y: 278,
    width: 95,
    height: 87
  },
  hbgaz: {
    index: 1,
    x: 729,
    y: 374,
    width: 95,
    height: 87
  },
  hbgba: {
    index: 1,
    x: 834,
    y: 374,
    width: 95,
    height: 87
  },
  hbgbc: {
    index: 1,
    x: 724,
    y: 470,
    width: 95,
    height: 87
  },
  hbgbd: {
    index: 1,
    x: 829,
    y: 470,
    width: 95,
    height: 87
  },
  hbg02: {
    index: 1,
    x: 944,
    y: 182,
    width: 47,
    height: 87
  },
  hbg04: {
    index: 1,
    x: 944,
    y: 278,
    width: 47,
    height: 87
  },
  hbg03: {
    index: 1,
    x: 939,
    y: 374,
    width: 39,
    height: 87
  },
  hbg01: {
    index: 1,
    x: 934,
    y: 470,
    width: 39,
    height: 87
  },
  hbg00i: {
    index: 1,
    x: 983,
    y: 470,
    width: 29,
    height: 87
  },
  hbg001i: {
    index: 1,
    x: 984,
    y: 864,
    width: 28,
    height: 87
  },
  hbg002i: {
    index: 1,
    x: 988,
    y: 374,
    width: 27,
    height: 87
  },
  hbg00: {
    index: 1,
    x: 992,
    y: 0,
    width: 23,
    height: 87
  },
  hbg000i: {
    index: 1,
    x: 1001,
    y: 96,
    width: 11,
    height: 87
  },
  hrb8: {
    index: 2,
    x: 0,
    y: 0,
    width: 589,
    height: 87
  },
  hrb13: {
    index: 2,
    x: 0,
    y: 96,
    width: 588,
    height: 87
  },
  hrb12: {
    index: 2,
    x: 0,
    y: 192,
    width: 584,
    height: 87
  },
  hrb14: {
    index: 2,
    x: 0,
    y: 288,
    width: 572,
    height: 87
  },
  hrb9: {
    index: 2,
    x: 0,
    y: 384,
    width: 570,
    height: 87
  },
  hrb11: {
    index: 2,
    x: 0,
    y: 480,
    width: 570,
    height: 87
  },
  hrb30: {
    index: 2,
    x: 0,
    y: 576,
    width: 515,
    height: 87
  },
  hrb15: {
    index: 2,
    x: 0,
    y: 672,
    width: 506,
    height: 87
  },
  hrb19: {
    index: 2,
    x: 0,
    y: 768,
    width: 500,
    height: 87
  },
  hrb18: {
    index: 2,
    x: 516,
    y: 672,
    width: 494,
    height: 87
  },
  hrb16: {
    index: 2,
    x: 510,
    y: 768,
    width: 493,
    height: 87
  },
  hrb17: {
    index: 2,
    x: 525,
    y: 576,
    width: 490,
    height: 87
  },
  hrb7: {
    index: 2,
    x: 0,
    y: 864,
    width: 474,
    height: 87
  },
  hrb6: {
    index: 2,
    x: 484,
    y: 864,
    width: 471,
    height: 87
  },
  hrb36: {
    index: 2,
    x: 582,
    y: 288,
    width: 423,
    height: 77
  },
  hrb32: {
    index: 2,
    x: 598,
    y: 96,
    width: 417,
    height: 77
  },
  hrb34: {
    index: 2,
    x: 599,
    y: 0,
    width: 415,
    height: 77
  },
  hrb1: {
    index: 2,
    x: 598,
    y: 182,
    width: 367,
    height: 87
  },
  hrb2: {
    index: 2,
    x: 582,
    y: 374,
    width: 355,
    height: 87
  },
  hrb5: {
    index: 2,
    x: 580,
    y: 470,
    width: 354,
    height: 87
  },
  hrb33: {
    index: 3,
    x: 0,
    y: 0,
    width: 450,
    height: 77
  },
  hrb31: {
    index: 3,
    x: 460,
    y: 0,
    width: 381,
    height: 77
  },
  hrb37: {
    index: 3,
    x: 0,
    y: 86,
    width: 363,
    height: 77
  },
  hbgbe: {
    index: 3,
    x: 851,
    y: 0,
    width: 95,
    height: 87
  },
  hbgaw: {
    index: 3,
    x: 373,
    y: 86,
    width: 95,
    height: 87
  },
  hgbad: {
    index: 3,
    x: 478,
    y: 86,
    width: 95,
    height: 87
  },
  hgbat: {
    index: 3,
    x: 583,
    y: 86,
    width: 95,
    height: 87
  },
  hbgaj: {
    index: 3,
    x: 688,
    y: 86,
    width: 95,
    height: 87
  },
  hbgaa: {
    index: 3,
    x: 793,
    y: 96,
    width: 95,
    height: 87
  },
  hbgab: {
    index: 3,
    x: 898,
    y: 96,
    width: 95,
    height: 87
  },
  hbgac: {
    index: 3,
    x: 0,
    y: 172,
    width: 95,
    height: 87
  },
  hbgae: {
    index: 3,
    x: 105,
    y: 172,
    width: 95,
    height: 87
  },
  hbgaf: {
    index: 3,
    x: 210,
    y: 172,
    width: 95,
    height: 87
  },
  hbgag: {
    index: 3,
    x: 315,
    y: 182,
    width: 95,
    height: 87
  },
  hbgah: {
    index: 3,
    x: 420,
    y: 182,
    width: 95,
    height: 87
  },
  hbgai: {
    index: 3,
    x: 525,
    y: 182,
    width: 95,
    height: 87
  },
  hbgak: {
    index: 3,
    x: 630,
    y: 182,
    width: 95,
    height: 87
  },
  hbgal: {
    index: 3,
    x: 735,
    y: 192,
    width: 95,
    height: 87
  },
  hbgam: {
    index: 3,
    x: 840,
    y: 192,
    width: 95,
    height: 87
  },
  hbgan: {
    index: 3,
    x: 0,
    y: 268,
    width: 95,
    height: 87
  },
  hbgao: {
    index: 3,
    x: 105,
    y: 268,
    width: 95,
    height: 87
  },
  hbgap: {
    index: 3,
    x: 210,
    y: 268,
    width: 95,
    height: 87
  },
  hbgaq: {
    index: 3,
    x: 315,
    y: 278,
    width: 95,
    height: 87
  },
  hbgar: {
    index: 3,
    x: 420,
    y: 278,
    width: 95,
    height: 87
  },
  hbgas: {
    index: 3,
    x: 525,
    y: 278,
    width: 95,
    height: 87
  },
  hbg03i: {
    index: 3,
    x: 630,
    y: 278,
    width: 87,
    height: 87
  },
  hbg02i: {
    index: 3,
    x: 727,
    y: 288,
    width: 87,
    height: 87
  },
  hbgc04: {
    index: 3,
    x: 824,
    y: 288,
    width: 87,
    height: 87
  },
  hbgc05: {
    index: 3,
    x: 921,
    y: 288,
    width: 87,
    height: 87
  },
  hbgc06: {
    index: 3,
    x: 0,
    y: 364,
    width: 87,
    height: 87
  },
  hbgc07: {
    index: 3,
    x: 97,
    y: 364,
    width: 87,
    height: 87
  },
  hbgc08: {
    index: 3,
    x: 194,
    y: 364,
    width: 87,
    height: 87
  },
  hbgc09: {
    index: 3,
    x: 291,
    y: 374,
    width: 87,
    height: 87
  },
  hbg04i: {
    index: 3,
    x: 388,
    y: 374,
    width: 87,
    height: 87
  },
  hbgc02: {
    index: 3,
    x: 485,
    y: 374,
    width: 87,
    height: 87
  },
  hbgc03: {
    index: 3,
    x: 582,
    y: 374,
    width: 87,
    height: 87
  },
  hbgc012: {
    index: 3,
    x: 679,
    y: 384,
    width: 87,
    height: 87
  },
  hbgc013: {
    index: 3,
    x: 776,
    y: 384,
    width: 87,
    height: 87
  },
  hbgc011: {
    index: 3,
    x: 873,
    y: 384,
    width: 87,
    height: 87
  },
  hbgc010: {
    index: 3,
    x: 0,
    y: 460,
    width: 87,
    height: 87
  },
  hbgc01: {
    index: 3,
    x: 97,
    y: 460,
    width: 87,
    height: 87
  },
  hbg07i: {
    index: 3,
    x: 194,
    y: 460,
    width: 87,
    height: 87
  },
  hbg06i: {
    index: 3,
    x: 291,
    y: 470,
    width: 87,
    height: 87
  },
  hbg05i: {
    index: 3,
    x: 388,
    y: 470,
    width: 87,
    height: 87
  }
}

class TextRenderer {
  private images: (HTMLImageElement | ImageBitmap | undefined)[] = []

  private async image(index: number) {
    if (index in this.images) return this.images[index]
    const res = await fetch(getAssetsPath(`harb${index}.png`))
    this.images[index] = await loadImage(
      new Uint8Array(await res.arrayBuffer())
    )
    return this.images[index]
  }

  async load(line: string) {
    for (const pt of line.split(/(<<\w+>>)/gi)) {
      const m = pt.match(/^<<(\w+)>>$/i)
      if (m) {
        const gdata = glyphs[m[1].toLowerCase()]
        if (!gdata) continue
        const { index } = gdata
        await this.image(index)
      }
    }
  }

  measure(ctx: CanvasRenderingContext2D, line: string, glyphSize = 36) {
    let result = 0
    for (const pt of line.split(/(<<\w+>>)/gi)) {
      const m = pt.match(/^<<(\w+)>>$/i)
      if (m) {
        const gdata = glyphs[m[1].toLowerCase()]
        if (!gdata) continue
        const { width, height } = gdata
        result += Math.ceil((glyphSize / height) * width)
      } else {
        result += ctx.measureText(pt).width
      }
    }
    return result
  }

  draw(
    ctx: CanvasRenderingContext2D,
    line: string,
    x: number,
    y: number,
    glyphSize = 36
  ) {
    for (const pt of line.split(/(<<\w+>>)/gi)) {
      const m = pt.match(/^<<(\w+)>>$/i)
      if (m) {
        const gdata = glyphs[m[1].toLowerCase()]
        if (!gdata) continue
        const { index, x: gx, y: gy, width, height } = gdata
        const img = this.images[index]
        if (!img) continue
        const scale = glyphSize / height
        ctx.drawImage(
          img,
          gx,
          gy,
          width,
          height,
          x,
          y - height * scale,
          width * scale,
          height * scale
        )
        x += Math.ceil(width * scale)
      } else {
        ctx.fillText(pt, x, y)
        x += ctx.measureText(pt).width
      }
    }
  }
}

export const textRenderer = new TextRenderer()
